/**
 * 深色主题上下文管理
 *
 * 这个文件负责管理应用程序的深色/浅色主题切换，包括：
 * - 主题状态管理
 * - DOM 类名切换
 * - 本地存储持久化
 */

import { createContext, useEffect, useState } from 'react'

/**
 * 深色主题上下文类型定义
 */
type darkContextType = {
  /** 当前主题状态 */
  dark: boolean
  /** 设置主题状态 */
  setDark: (newState: boolean) => void
}

/**
 * 深色主题上下文的初始值
 */
const initialValue = {
  dark: false,
  setDark: () => {}
}

// 创建深色主题上下文
export const darkContext = createContext<darkContextType>(initialValue)

/**
 * 深色主题提供者组件
 *
 * @param children - 子组件
 * @returns 提供深色主题相关状态和方法的上下文提供者
 */
export function DarkProvider({ children }) {
  const [dark, setDark] = useState(
    false
    // JSON.parse(window.localStorage.getItem("isDark")) ?? false
  )

  /**
   * 监听主题状态变化，更新 DOM 和本地存储
   */
  useEffect(() => {
    if (dark) {
      // 添加深色主题类名
      document.getElementById('body').classList.add('dark')
    } else {
      // 移除深色主题类名
      document.getElementById('body').classList.remove('dark')
    }
    // 保存主题状态到本地存储
    window.localStorage.setItem('isDark', dark.toString())
  }, [dark])

  return (
    <darkContext.Provider
      value={{
        dark,
        setDark
      }}
    >
      {children}
    </darkContext.Provider>
  )
}
